import { YardTruck } from ".";

export default class TruckRoute extends YardTruck {
	get singularNoun() {
		return "truck route";
	}

	resource() {
		return "yard/trucks/routes";
	}
}
